import axios from "axios";
import { Master_Service_TEAMS_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const teamAadharDetailsActions = {
  SAVE_TEAMS_AADHAR_DETAILS_SUCCESS: "SAVE_TEAMS_AADHAR_DETAILS_SUCCESS",
  SAVE_TEAMS_AADHAR_DETAILS_ERROR: "SAVE_TEAMS_AADHAR_DETAILS_ERROR",
};

export function saveTeamsAadharDetails(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_TEAMS_URL}/partnerTeamAadhaarVerification`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveTeamsAadharDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveTeamsAadharDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveTeamsAadharDetailsError(err));
          return err.response;
        }
      });
}

export function saveTeamsAadharDetailsError(error) {
  return {
    type: teamAadharDetailsActions.SAVE_TEAMS_AADHAR_DETAILS_ERROR,
    payload: error,
  };
}

export function saveTeamsAadharDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: teamAadharDetailsActions.SAVE_TEAMS_AADHAR_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
